<script>
  import { onMount } from "svelte";
  import { v4 } from "uuid";
  import { resetDefaultStyle } from "../../Utils/utilFunctions.svelte";
  import { createEventDispatcher } from "svelte";
  import CustomDateRangeInput from "../Custom/DateInput/CustomDateRangeInput.svelte";

  export let placeholder = "",
    title = "Date Range",
    titleClass = "",
    value = null,
    startDate = null,
    endDate = null,
    disabled = false,
    id = "",
    isLong = true,
    showTime = false,
    showYearDropdown = true,
    minDate = "",
    inputClass,
    showAbove = false,
    wrapperClass = "",
    wrapperClassFocus = "",
    maxDate = "",
    showClearButton = false;

  export let minYear,
    maxYear,
    showScrollYearOptions = false,
    yearOptionSize;

  let defaultTitleClass = "text-[11px] font-[500]",
    defaultClass = "input-sm px-0";

  $: min = minDate ? new Date(minDate) : new Date("1900-01-01");
  $: max = maxDate ? new Date(maxDate) : new Date("2999-12-31");

  const uuid = v4(),
    dispatch = createEventDispatcher();

  let displayStartDate = null,
    displayEndDate = null;

  onMount(() => {
    if (startDate) {
      displayStartDate = new Date(startDate);
    } else displayStartDate = null;
    if (endDate) {
      displayEndDate = new Date(endDate);
    } else displayEndDate = null;

    min = minDate ? new Date(minDate) : new Date("1900-01-01");
    max = maxDate ? new Date(maxDate) : new Date("2999-12-31");

    handleSelectDate();

    const dateInput = document.getElementById(id ? id : uuid);

    if (dateInput)
      dateInput.addEventListener("focus", () => {
        resetDefaultStyle(id ? id : uuid);
      });

    const containers = document.querySelectorAll(".date-time-field");

    containers.forEach((element) => {
      element.classList.remove("w-full");
      element.classList.add("w-full");
    });
  });

  export const refreshValue = () => {
    if (startDate) displayStartDate = new Date(startDate);
    else displayStartDate = null;
    if (endDate) displayEndDate = new Date(endDate);
    else displayEndDate = null;
  };

  $: if (startDate) {
    displayStartDate = new Date(startDate);
  } else displayStartDate = null;

  $: if (endDate) {
    displayEndDate = new Date(endDate);
  } else displayEndDate = null;

  const handleSelectDate = () => {
    const originalStartDate = displayStartDate
      ? new Date(displayStartDate)
      : null;
    const originalEndDate = displayEndDate ? new Date(displayEndDate) : null;

    if (originalStartDate) {
      const year = originalStartDate.getFullYear();
      const month = (originalStartDate.getMonth() + 1)
        .toString()
        .padStart(2, "0");
      const day = originalStartDate.getDate().toString().padStart(2, "0");

      const hours = originalStartDate.getHours().toString().padStart(2, "0");
      const minutes = originalStartDate
        .getMinutes()
        .toString()
        .padStart(2, "0");
      const seconds = originalStartDate
        .getSeconds()
        .toString()
        .padStart(2, "0");

      startDate = showTime
        ? `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`
        : `${year}-${month}-${day}`;
    } else {
      startDate = null;
    }

    if (originalEndDate) {
      const year = originalEndDate.getFullYear();
      const month = (originalEndDate.getMonth() + 1)
        .toString()
        .padStart(2, "0");
      const day = originalEndDate.getDate().toString().padStart(2, "0");

      const hours = originalEndDate.getHours().toString().padStart(2, "0");
      const minutes = originalEndDate.getMinutes().toString().padStart(2, "0");
      const seconds = originalEndDate.getSeconds().toString().padStart(2, "0");

      endDate = showTime
        ? `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`
        : `${year}-${month}-${day}`;
    } else {
      endDate = null;
    }

    if (!startDate && !endDate) dispatch("valueCleared");
  };
</script>

<div class="flex flex-col">
  <p class={defaultTitleClass + " " + titleClass}>{title}</p>
  <div class="flex flex-1 w-full no-transform">
    <CustomDateRangeInput
      bind:startValue={displayStartDate}
      bind:endValue={displayEndDate}
      closeOnSelection="true"
      format={showTime ? "dd/MM/yyyy HH:mm" : "dd/MM/yyyy"}
      valid="true"
      {placeholder}
      id={id ? id : uuid}
      {min}
      {max}
      {showTime}
      {showAbove}
      {inputClass}
      wrapperClass="{defaultClass} {wrapperClass}"
      {wrapperClassFocus}
      {showYearDropdown}
      {showClearButton}
      timePrecision="minute"
      {disabled}
      browseWithoutSelecting
      dynamicPositioning
      on:change={() => {
        handleSelectDate();
        dispatch("change");
        resetDefaultStyle(id ? id : uuid);
      }}
      {minYear}
      {maxYear}
      {showScrollYearOptions}
      {yearOptionSize}
    />
  </div>
</div>
